export const FETCH_EFORM_CONFIG_SUCCESS = '@@appConfig/FETCH_EFORM_CONFIG_SUCCESS';
export const a = 'b';
